import form from './form.js';
import index from './index.js';
import { Router } from '@/legacy/Router';

Router.get('judging/score-set/:any', form);
Router.get('judging/score-set', index);
